export default __webpack_public_path__ + "static/media/blogpost1.9223a9a0.jpg";